import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { NsTextInput } from 'components/common/ns-text-input/NsTextInput';
import NsInputterEvent from '../ns-inputter/NsInputterEvent';

type NsBankAccountInputProps = {
  id?: string;
  name?: string;
  label?: string;
  testId?: string;
  onChange?: (event: NsInputterEvent) => void;
  value?: string;
  inputAttributes?: Record<string, string | boolean>;
};

export const NsBankAccountInput = ({
  id = 'bankAccountField',
  name = 'bankAccountField',
  label = 'Account number',
  value,
  testId,
  onChange,
  inputAttributes
}: NsBankAccountInputProps) => {
  return (
    <NsTextInput
      id={id}
      testId={testId}
      value={value}
      label={label}
      name={name}
      inputAttributes={inputAttributes}
      pattern="^[0-9]*$"
      mask="--------"
      onChange={onChange}
      validation={[
        NsInputterValidations.isRequired,
        NsInputterValidations.isInteger
      ]}
    />
  );
};
